import { Resource } from "./resource.js";
/** Immutable PipelineLayout object */
export class PipelineLayout extends Resource {
    get [Symbol.toStringTag]() {
        return 'PipelineLayout';
    }
    constructor(device, props) {
        super(device, props, PipelineLayout.defaultProps);
    }
    static defaultProps = {
        ...Resource.defaultProps,
        shaderLayout: {
            attributes: [],
            bindings: []
        }
    };
}
//# sourceMappingURL=pipeline-layout.js.map